export default __webpack_public_path__ + "static/media/footer2.a51924d0.jpg";